import { useAppDispatch } from '../../../../App/redux/store';

import Button from '../../../../components/Assets/Button';
import { subscriptionUpdateType } from '../askForSubscriptionUpdateModal/subscriptionModalConstants';

import { modalsActions } from '../../../modals/modalsSlice';
import styles from './askForSubscriptionUpdateSummaryModal.module.scss';

interface IAskForSubscriptionUpdateSummaryModalProps {
  datas: SubscriptionUpdateFormType;
}

function AskForSubscriptionUpdateSummaryModal({
  datas,
}: IAskForSubscriptionUpdateSummaryModalProps) {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(modalsActions.subscriptionUpdateSummary(null));
  };

  const type = subscriptionUpdateType.find((f) => f.value === datas.title) ?? null;

  // useEffect(() => {
  //   return () => {
  //     dispatch(modalsActions.askForSubscriptionUpdate(false));
  //   };
  // }, []);

  return (
    <div className={styles.overlay}>
      <div className={styles.subscriptionSummary}>
        <h2>Modification d&apos;abonnement</h2>
        <h4>Confirmation de demande</h4>

        <p className="subscription-summary-type">
          <span>Object :</span>
          {type?.summaryType ?? 'Inconnu'}
        </p>

        <p className="subscription-summary-comment">
          <span>Commentaire :</span>
          {` ${datas.comment ?? 'Aucun'}`}
        </p>

        <p className={styles.confirmSentense}>
          Nous avons bien reçu votre demande et nous vous contacterons dans les plus
          bref delais.
        </p>

        <Button
          btnType="button"
          btnContent="FERMER"
          handleClick={handleClose}
          textColor="white"
          bgColor="violet"
          borderColor="violet"
        />
      </div>
    </div>
  );
}

export default AskForSubscriptionUpdateSummaryModal;
